export default __webpack_public_path__ + "static/media/UPP-Logotype-Landscape-Tomato-Transparent.ed6b4c12.png";